import { Formik } from 'formik'

// Libs
import getformikConfig from './formikConfig'

export const defaultProps = {}

function InvitationFormik(props: any) {
  const { children } = props

  const formikConfig = getformikConfig(props)

  return <Formik {...formikConfig}>{() => children}</Formik>
}

InvitationFormik.defaultProps = defaultProps

export default InvitationFormik
